import React, { useState, useEffect, useRef } from 'react';
// 1. IMPORT THE HELPER
import { getImagePath } from './config/imagePath';

const ColorSelector = ({ label, options, selectedValue, onChange }) => {

  // Determine initial category based on selection
  const getInitialCategory = () => {
    if (!selectedValue) return "solid";
    const selectedOption = options.find(o => o.id === selectedValue);
    // Safety check: ensure the option exists before checking category
    return selectedOption && selectedOption.category ? selectedOption.category : "solid";
  };

  const [activeCategory, setActiveCategory] = useState(getInitialCategory());
  
  // Ref to track the last selected value to prevent infinite loops
  const lastSelectedValue = useRef(selectedValue);

  // Switch tabs if the ACTUAL SELECTED COLOR changed (from props)
  useEffect(() => {
    if (selectedValue && selectedValue !== lastSelectedValue.current) {
        const selectedOption = options.find(o => o.id === selectedValue);
        if (selectedOption && selectedOption.category && selectedOption.category !== activeCategory) {
            setActiveCategory(selectedOption.category);
        }
        lastSelectedValue.current = selectedValue;
    }
  }, [selectedValue, options, activeCategory]);

  // Filter options based on active tab
  const displayedOptions = options.filter(opt => opt.category === activeCategory);

  const categories = [
    { id: "solid", label: "Solids" },
    { id: "texture", label: "Textures" },
    { id: "carbon", label: "Carbon Fiber" },
    { id: "camo", label: "Camo" } // Changed from Camouflage to Camo
  ];

  return (
    <div style={{ marginBottom: "25px" }}>
      
      {/* HEADER + SELECTED NAME */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px", alignItems: "baseline" }}>
        <label style={{ fontWeight: "bold", textTransform: "uppercase", fontSize: "14px", color: "#fff" }}>
          {label}
        </label>
        <span style={{ fontSize: "12px", color: "#D5A678", fontStyle: "italic" }}>
          {options.find(o => o.id === selectedValue)?.name || "Select Color"}
        </span>
      </div>

      {/* TABS */}
      <div style={{ display: "flex", gap: "5px", marginBottom: "15px", borderBottom: "1px solid #333", paddingBottom: "10px", overflowX: "auto" }}>
        {categories.map(cat => (
            <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                style={{
                    background: activeCategory === cat.id ? "#D5A678" : "transparent",
                    color: activeCategory === cat.id ? "#000" : "#888",
                    border: activeCategory === cat.id ? "1px solid #D5A678" : "1px solid #444",
                    borderRadius: "20px",
                    padding: "6px 12px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    transition: "all 0.2s ease"
                }}
            >
                {cat.label}
            </button>
        ))}
      </div>
      
      {/* THE GRID (Filtered) */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
        {displayedOptions.map((opt) => {
          const isSelected = selectedValue === opt.id;
          
          // --- UPDATED BACKGROUND LOGIC ---
          // 1. Calculate the dynamic image path if an image exists
          let bgImage = "none";
          if (opt.img) {
              // Strip the old hardcoded path if it exists in the data
              const cleanPath = opt.img.replace('/anr-builder/images/', '');
              // Wrap it in our helper to get the WordPress Uploads URL
              bgImage = `url(${getImagePath(cleanPath)})`;
          }

          const backgroundStyle = {
             backgroundColor: opt.hex || "#ccc",
             backgroundImage: bgImage, // Use the new dynamic variable
             backgroundSize: "cover",
             backgroundPosition: "center"
          };

          return (
            <div
              key={opt.id}
              onClick={() => onChange(opt.id)}
              title={opt.name}
              style={{
                cursor: "pointer",
                position: "relative",
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                border: isSelected ? "3px solid #D5A678" : "2px solid #444",
                boxShadow: isSelected ? "0 0 15px rgba(213, 166, 120, 0.4)" : "none",
                transform: isSelected ? "scale(1.1)" : "scale(1)",
                transition: "all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                ...backgroundStyle
              }}
            >
              {/* Price Tag Badge */}
              {opt.price > 0 && (
                <div style={{
                  position: "absolute",
                  bottom: "-5px",
                  right: "-5px",
                  backgroundColor: "#333",
                  color: "#D5A678",
                  fontSize: "9px",
                  padding: "2px 4px",
                  borderRadius: "4px",
                  fontWeight: "bold",
                  border: "1px solid #444"
                }}>
                  +${opt.price}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ColorSelector;